import React, { useState, useEffect } from "react";
import { useUserContext } from "src/contexts/userContext";
import { useHighRiskContext } from "src/contexts/high_risk/highriskContext";
import * as API from "src/api/product";
import * as REQ from "src/api/request";
import { DatePicker, InputNumber, TreeSelect } from "antd";
import _ from "lodash";
import moment from "moment";
import { UnitFilter } from "src/components/filters";
import PageHelp from "src/components/help/PageHelp";
const Header = () => {
  const { user, message } = useUserContext();
  const { state, dispatch } = useHighRiskContext();
  const [open, setOpen] = useState(false);

  // Header анх ачаалагдах үед DepartmentTreeCode-ийн дотоод auto-select-аас
  // үл хамааран бие даан сонголтыг тогтооно — context.list_department нь
  // бэлэн биш (user.is_emc=false) тохиолдолд ч ажиллана.
  //
  //   1) Tseh_code яг таарах department олдох уу → түүнийг сонгох
  //   2) Tseh_code-ийн "эхний хэсэг"-ээр (prefix) хайх → анхных нь олдвол сонгох
  //   3) Олдохгүй бол "Бүгд" (0) сонгох — backend dep_code-гүй бол бүгдийг буцаана
  useEffect(() => {
    if (state?.department != null) return;
    REQ.getUserDepartment().then((res) => {
      if (!res?.length) return;
      var department = _.find(res, {
        departmentcode: user?.info?.tseh_code,
      });
      var nextDep = department?.departmentcode;
      if (nextDep == null && user?.info?.tseh_code) {
        var prefix = String(user.info.tseh_code).split(".")[0];
        var match = _.find(res, function (d) {
          return String(d.departmentcode || "").startsWith(prefix);
        });
        if (match) nextDep = match.departmentcode;
      }
      if (nextDep == null) nextDep = 0;
      dispatch({
        type: "STATE",
        data: { department: nextDep },
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mb-2 pb-2 flex flex-col md:flex-row gap-3">
      <div className="flex items-center justify-between text-xs">
        <span className="md:w-[70px] font-semibold pr-1">Жил:</span>
        <div className="w-full md:min-w-[150px] ">
          <DatePicker
            allowClear={false}
            className="w-full md:w-[150px] text-xs"
            picker="year"
            value={moment(state.end_date)}
            onChange={(date) => {
              dispatch({
                type: "STATE",
                data: { end_date: date },
              });
            }}
          />
        </div>
      </div>

      {/* ⚠ БН + ХЭСЭГ/НЭГЖ — бусад бүх хуудастай ИЖИЛ бүрэлдэхүүн
          (`UnitFilter`). Өмнө нь энд ганц мод сонгогч (`DepartmentTreeCode`)
          байсан тул «цех сонгоод дотор нь хэсгээр шүүх» боломжгүй, мөн
          хяналт шалгалт / зөрчлийн хуудаснаас өөр зан үйлтэй байв
          (2026-09-26). ХЭСГИЙН шүүлт нь `state.section` — жагсаалтыг
          `department_code` угтвараар шүүнэ (list.js). */}
      <div className="flex items-center w-full md:min-w-[380px] text-xs gap-2">
        <span className="font-semibold whitespace-nowrap">Бүтцийн нэгж:</span>
        <UnitFilter
          deptCode={state.department === 0 ? "" : state.department}
          deptParentId={state.department_parent_id}
          sectionCode={state.section}
          autoSelectOwn
          onDeptChange={(code, parentId) => {
            dispatch({
              type: "STATE",
              data: {
                department: code || 0,
                department_parent_id: parentId || null,
                section: "",
              },
            });
          }}
          onSectionChange={(code, name) => {
            dispatch({
              type: "STATE",
              data: {
                section: code || "",
                register: {
                  ...state.register,
                  negj_code: code || null,
                  negj_name: name || null,
                },
              },
            });
          }}
        />
        {/* 
        <TreeSelect
          showSearch
          allowClear={true}
          placeholder="Сонгоно уу"
          treeDataSimpleMode={true}
          className="w-full md:max-w-[500px]"
          treeData={state?.list_department}
          treeLine={(true, { showLeafIcon: false })}
          value={state.department}
          onChange={(value) => {
            dispatch({
              type: "STATE",
              data: { department: value },
            });
          }}
          filterTreeNode={(search, item) =>
            item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
          }
          open={open}
          onDropdownVisibleChange={(open) => setOpen(open)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              console.log(e.target.value);
              var reportdepartment = _.find(state?.list_department, {
                departmentcode: e.target.value,
              });
              console.log(reportdepartment);
              if (reportdepartment) {
                dispatch({
                  type: "STATE",
                  data: { department: reportdepartment.id },
                });
                setOpen(false);
              }
            }
          }}
        /> */}
        {/* <div className="flex items-center w-full text-xs">
        <span className="font-semibold whitespace-nowrap pr-5">Төрөл:</span>
        <Select
          value={state.datetype1}
          onChange={(value) => {
            dispatch({ type: "STATE", data: { datetype1: value } });
          }}
          className="w-full md:max-w-[400px] read-only: true"
        >
          <Option key="1" value="date_norm">
            Үндсэн нормын хугацаагаар
          </Option>
          <Option key="2" value="date_applied">
            Олгосон огноогоор
          </Option>
        </Select>
      </div> */}
      </div>

      {/* Тусламж — шүүлтийн мөрийн ТӨГСГӨЛД. Эдгээр хуудсанд гарчиг
          байхгүй тул толгойн баруун тал нь цорын ганц тогтвортой байр.
          Түлхүүр өгөөгүй нь САНААТАЙ — энэ толгойг хэд хэдэн зам
          хуваан ашигладаг тул PageHelp замаасаа өөрөө уншина. */}
      <div className="flex items-center">
        <PageHelp />
      </div>
    </div>
  );
};
export default Header;
